var $window, $body;
$(function() { initialise(); });

function initialise() {
  $window = $(window);
  $body   = $("body");

  // ── Week view (DataTables) ──────────────────────────────────────────────
  if ($('table.week').length) {
    $('table.week').DataTable({
      "autoWidth": false,
      "aLengthMenu": [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      "iDisplayLength": -1,
      "order": [],
    });
  }

  // ── Collapse/expand day sections ───────────────────────────────────────
  $('table thead tr.date-row').click(function() {
    $(this).toggleClass('hidden');
    $(this).parent('thead').next().toggleClass('hidden');
  });

  // ── Calendar key toggle ────────────────────────────────────────────────
  $("#calendar-key-link").click(function() {
    $("#calendar-key-content").slideToggle(500);
  });
}

